"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.fontWeights = void 0;
exports.fontWeights = {
    regular: '400',
    medium: '500',
    bold: '700',
};
//# sourceMappingURL=fontWeights.js.map